import type { HTMLAttributes, ReactNode } from 'react';
import './ConstraintChip.css';

export interface ConstraintChipProps extends HTMLAttributes<HTMLSpanElement> {
  label?: ReactNode;
  value: ReactNode;
  note?: ReactNode;
  variant?: 'default' | 'derived' | 'flag';
}

export function ConstraintChip({
  label,
  value,
  note,
  variant = 'default',
  style,
  ...rest
}: ConstraintChipProps) {
  return (
    <span className={`uc-cchip uc-cchip--${variant}`} style={style} {...rest}>
      {label && <span className="uc-cchip__key">{label}</span>}
      <span className="uc-cchip__val">{value}</span>
      {note && <span className="uc-cchip__tail">{note}</span>}
    </span>
  );
}
